<template lang="pug">
v-app-bar.white.elevation-0.app-bar(app light style="box-shadow: 0 2px 4px 0 rgba(0,0,0,.08) !important;")
  a(@click="$isMobile ? '' : $router.push('/')")
    v-img.mt-1.ml-2(:src="require('@/assets/images/logo_main.png')" max-height="40" max-width="100" contain)
  v-spacer
  template(v-if="$route.name !== 'SignIn'")
    v-btn.text-none.title(v-if="!user" text @click="$router.push('/signin')" x-large) {{ $t('sign_in') }}
    v-btn.text-none.title(v-else text @click="$router.push('/signout')" x-large) {{ $t('sign_out') }}
  template(v-else)
    v-btn.text-none.title(v-if="showSignUpBtn" text @click="$router.push('/signup')" x-large) {{ $t('create_account') }}
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'TopBar',
  data: () => ({
  }),
  computed: {
    ...mapState('user', ['user']),
    showSignUpBtn () {
      return this.$isLandingPage || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>